module.exports = __webpack_public_path__ + "static/img/D-Clics-Numeriques.2008eff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/D-Clics-Numeriques.svg
// module id = 536
// module chunks = 2